import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Success() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <script type="text/javascript">
          {`
            gtag('event', 'ads_conversion_SUBMIT_LEAD_FORM_1', {
              // Optional parameters
            });
          `}
        </script>
      </Helmet>

      <div className="quote-success">
        <p>{t("quoteSuccessThanks")}</p>
        <p>
          <Link to="/" className="quote-success-link">
            {t("quoteBackToHome")}
          </Link>
        </p>
      </div>
    </>
  );
}
